import React, { useEffect, useMemo } from 'react'
import { Provider, useSelector } from 'react-redux'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { ConfigProvider } from 'antd'
import moment from 'moment'
import ruLang from 'antd/es/locale/ru_RU'
import 'moment/locale/ru'
import Normalize from '../styles/normalize'
import GlobalStyle from '../styles/main'
import FontsStyle from '../styles/fonts'
import CustomFormBordersStyles from '../styles/custom-form-borders'
import {
  applySystemThemeCssVars,
  createAntdTheme,
  createStyledTheme,
  resolveSystemTheme,
} from '../styles/system-theme'
import './b2b.less'
import { DesktopRouter } from './desktop-router'
//import { MobileRouter } from './mobile-router'
import 'antd/dist/reset.css'
import { HeaderActionsProvider } from '../contexts/header-actions-context'
import { NavigationBlockerProvider } from '../contexts/navigation-blocker-context'

moment.locale('ru')

const GlobalStyles = createGlobalStyle`
  ${Normalize}
  ${GlobalStyle}
  ${FontsStyle}
  ${CustomFormBordersStyles}
`

function ThemedApp() {
  const systemThemePayload = useSelector((state: any) => state.session?.sessionData?.systemTheme)
  const systemTheme = useMemo(() => resolveSystemTheme(systemThemePayload), [systemThemePayload])
  const styledTheme = useMemo(() => createStyledTheme(systemTheme), [systemTheme])
  const antdTheme = useMemo(() => createAntdTheme(systemTheme), [systemTheme])

  useEffect(() => {
    applySystemThemeCssVars(systemTheme)
  }, [systemTheme])

  return (
    <ThemeProvider theme={styledTheme}>
      <ConfigProvider locale={ruLang} theme={antdTheme}>
        <HeaderActionsProvider>
          <NavigationBlockerProvider>
            <DesktopRouter />
          </NavigationBlockerProvider>
        </HeaderActionsProvider>
      </ConfigProvider>
      <GlobalStyles />
    </ThemeProvider>
  )
}

function App({ store }) {
  return (
    <Provider store={store}>
      <ThemedApp />
    </Provider>
  )
}

export default App
